import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {AuthConst} from "@consts";
import {Box, DI, FirebaseService, Loading, StorageService, UrlUtils} from "shared-lib";
import {Button, Form, Stack} from "react-bootstrap";
import {useLocation, useNavigate} from "react-router-dom";
import {User} from "firebase/auth";

const firebaseService: FirebaseService = DI.get(FirebaseService);
const storageService: StorageService = DI.get(StorageService);


type Props = {};
type States = { inProgress: boolean, verificationId: string, user: User, phoneNumber: number, askPhoneNumber: boolean };
export const PhoneNumberVerificationPage: React.FunctionComponent<Props> = () => {

    const {register, handleSubmit, formState: {errors}} = useForm({shouldUnregister: true});
    const {t} = useTranslation();
    const {state: routerState} = useLocation();
    const navigate = useNavigate();
    const [states, setStates] = useState({
        user: firebaseService.getCurrentUser(),
        phoneNumber: ((routerState || {}) as any).phoneNumber
    } as States);


    useEffect(() => {
        if (states.user) {
            if (states.phoneNumber) {
                onPhoneNumberSubmit({phoneNumber: states.phoneNumber});
            } else {
                setStates({...states, askPhoneNumber: true});
            }

        } else {
            navigate('/', {replace: true});
        }
    }, []);


    const onPhoneNumberSubmit = ({phoneNumber}) => {
        firebaseService.getPhoneVerificationId('reCAPTCHA-container', states.user, `+9${phoneNumber}`)
            .then(verificationId => {
                setStates({...states, verificationId, askPhoneNumber: false});
            });
    }

    const onVerificationCodeSubmit = ({verificationCode}) => {
        setStates({...states, inProgress: true});
        firebaseService.updatePhoneNumber(states.user, states.verificationId, verificationCode)
            .then(() => {
                const email = states.user.email;
                firebaseService.sendEmailVerification(
                    states.user,
                    UrlUtils.generateAbsoluteUrl(AuthConst.SIGN_IN_PAGE, {email})
                ).then(() => {
                    navigate(AuthConst.SIGN_UP_RESULT_PAGE, {replace: true});
                });
            });
    }

    const renderByCase = () => {
        if (states.askPhoneNumber) {
            return (<>
                    <p>{t('phoneNumberVerification.enterPhoneNumberMessage')}</p>
                    <Form onSubmit={handleSubmit(onPhoneNumberSubmit)}>
                        <Form.Group className="mb-3">
                            <Form.Control
                                size="lg"
                                type="text"
                                placeholder={t('common.input.placeholder.phoneNumber')}
                                isInvalid={!!errors.phoneNumber}
                                {...register("phoneNumber", {
                                    required: t('common.input.required'),
                                    pattern: {
                                        value: /^05[0-9]{9}$/,
                                        message: t('common.input.phone.notMatchedPattern')
                                    }
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.phoneNumber?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Button id="submit-btn" variant="primary" type="submit"
                                className="w-100 btn-lg">{t('phoneNumberVerification.phoneNumberSubmit')}</Button>
                    </Form>
                </>
            );
        } else {
            return (
                <div id="form-container">
                    <p>{t('phoneNumberVerification.message')}</p>
                    <Form onSubmit={handleSubmit(onVerificationCodeSubmit)}>
                        <Form.Group className="mb-3">
                            <Form.Control
                                size="lg"
                                type="text"
                                placeholder={t('common.input.placeholder.verificationCode')}
                                isInvalid={!!errors.verificationCode}
                                {...register("verificationCode", {required: true})}
                            />
                            <Form.Control.Feedback type="invalid">
                                {t('common.input.required')}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Button id="submit-btn" variant="primary" type="submit"
                                className="w-100 btn-lg">{t('phoneNumberVerification.verificationSubmit')}</Button>
                    </Form>
                </div>
            );
        }
    }

    return (
        <Stack className="login-page min-vh-100 justify-content-center align-items-center bg-dark">
            <img className="login-page__logo mb-4" src="./logo_440x64.png"/>
            <Box className="login-page__form">
                <Loading show={states.inProgress}/>
                <div id="reCAPTCHA-container"></div>
                {renderByCase()}
            </Box>
        </Stack>
    );


}